import { type ExamCenterProctor } from '@exam-center/graphql';
import { isEnglishTitle, isThaiTitle, zodResolver } from '@shared/utils';
import { type PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { type AdminProctorDetailsFormInput, AdminProctorDetailsFormSchema } from './schema';

interface AdminProctorDetailsFormProviderProps extends PropsWithChildren {
  initialValues?: ExamCenterProctor;
}

export default function AdminProctorDetailsFormProvider(
  props: Readonly<AdminProctorDetailsFormProviderProps>,
) {
  const { children, initialValues } = props;

  const formContext = useForm<AdminProctorDetailsFormInput>({
    resolver: zodResolver(AdminProctorDetailsFormSchema),
    defaultValues: {
      proctorType: initialValues?.type,
      titleTh:
        initialValues?.titleTh && isThaiTitle(initialValues.titleTh)
          ? { value: initialValues.titleTh, label: initialValues.titleTh }
          : null,
      firstNameTh: initialValues?.firstNameTh,
      lastNameTh: initialValues?.lastNameTh,
      titleEn:
        initialValues?.titleEn && isEnglishTitle(initialValues.titleEn)
          ? { value: initialValues.titleEn, label: initialValues.titleEn }
          : null,
      firstNameEn: initialValues?.firstNameEn ?? '',
      lastNameEn: initialValues?.lastNameEn ?? '',
      email: initialValues?.email ?? '',
      phoneNumber: initialValues?.phoneNumber,
      address: initialValues?.address ?? '',
      employeeInfo: {
        code: initialValues?.metadata?.employeeId,
        position: initialValues?.metadata?.position,
        department: initialValues?.metadata?.department,
        startedAt: initialValues?.startedAt ? new Date(initialValues.startedAt) : undefined,
        termination: {
          endedAt: initialValues?.endedAt ? new Date(initialValues.endedAt) : undefined,
          isAssigned: initialValues?.endedAt ? 'true' : 'false',
        },
      },
    },
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
